import React from 'react'
import { Box } from '@mui/material'
import parse from 'html-react-parser'

import { WPCF7Form } from '@/types'

export type HtmlFieldProps = {
  field: WPCF7Form['form'][0]
}

const HtmlField = ({ field }: HtmlFieldProps) => {
  return (
    <Box
      sx={{
        typography: 'textRegular',
        color: 'text.primary',
        '& a': {
          color: 'currentColor'
        }
      }}
    >
      {parse(field.content || '')}
    </Box>
  )
}

export default HtmlField
